export const ENV = {
    mode: 'Development',
    GOOGLE_MAP_API_KEY: 'AIzaSyD4ZhOfhsWIII7qOYKRS2SfKZ1iPeIeQfU',
    BUILD: '',
    DEBUG: true,
    API_URL: '/1.0/',
    API_URLS: {
        prod: 'https://headlight.com/1.0/',
        stg: 'https://stg.headlight.com/1.0/',
        demo: 'https://demo.headlight.com/1.0/',
        qa: 'https://qa.headlight.com/1.0/'

    },
    BuildTime: 'Wed Sep 23 2026 18:23:59 GMT+0000 (Coordinated Universal Time)',
    GIT_SHA: '89549df89469a1c6d49851cc23a22aaac4e91db4',
    Version: '1.9.1',
    Bundle: '1',
    Script: 'Test'
};


// WEBPACK FOOTER //
// ./src/environments/environment.dev.ts